module.exports = __webpack_public_path__ + "static/img/logo.63ed29f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 26